import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { LinearGaugeComponent, AxesDirective, AxisDirective, PointersDirective, PointerDirective, RangesDirective, RangeDirective } from '@syncfusion/ej2-react-lineargauge';
import useWindowSize from '../../hooks/useWindowSize';
import TickIcon from '../../assets/images/tick-icon.png'

function StepProgressBar({ steps }) {
    // Declare variables using const or let
    const { width } = useWindowSize();
    const fontSize = width >= 1024 ? '20px' : '12px';
    const location = useLocation();

    // Declare state variables using useState
    const [currentStep, setCurrentStep] = useState(0);

    // Declare effects using useEffect
    useEffect(() => {
        let pathname = location.pathname
        let step = steps[currentStep];
        if (!step || (step && pathname !== step.path)) {
            if (pathname === "/") {
                setCurrentStep(0);
            }
            else if (pathname === "/submitted" || pathname === "/completed" || pathname === '/alreadysubmitted') {
                setCurrentStep(steps.length);
            }  else {
                let currentFormStep = steps.filter((step) => step.path === pathname);
                if (currentFormStep.length > 0) {
                    setCurrentStep(currentFormStep[0].id);
                } 
            }
        }

    }, [location, steps, currentStep])

    // Declare event handlers or other functions
    function axisLabelRender(args) {
        let pathname = location.pathname
        var step = steps[args.text];
        if (step) {
            if (width > 600) {
                args.text = step.title;
            } else {
                if (step.path === pathname | steps.length <= 3) {
                    args.text = step.title;
                } else {
                    args.text = step.id + 1;
                }
            }
        } else {
            args.text = " ";
        }
    }

    return (
        <div className='container control-pane mb-5'>
            <div className='control-section'>
                <LinearGaugeComponent axisLabelRender={axisLabelRender.bind(this)} id='gauge' height='100' background='transparent' orientation='Horizontal'>
                    <AxesDirective>
                        <AxisDirective minimum={0} maximum={steps.length - 1} opposedPosition={true} majorTicks={{ interval: 1, height: 0 }} minorTicks={{ height: 0 }} line={{ width: 5 }} labelStyle={{ offset: 20, font: { size: fontSize , fontFamily: 'inherit' } }}>
                            <PointersDirective>
                                {steps.map((step) => (
                                    <PointerDirective
                                        key={step.id}
                                        value={step.id}
                                        height={25}
                                        width={currentStep > step.id ? 25 : 15}
                                        placement={currentStep > step.id ? 'Near' : 'Center'}
                                        position={currentStep > step.id ? '' : 'Cross'}
                                        offset={-2}
                                        markerType={currentStep > step.id ? 'Image' : 'Circle'}
                                        color='#D1D9DD'
                                        text={step.title}
                                        imageUrl={TickIcon}
                                    />
                                ))}
                            </PointersDirective>
                            <RangesDirective>
                                {steps.map((step) => (
                                    <RangeDirective key={step.title} start={step.id} end={step.id + 1} startWidth={5} endWidth={5} color={currentStep > step.id ? '#1FAC8A' : '#D1D9DD'} />                                 
                                ))}
                            </RangesDirective>
                        </AxisDirective>
                    </AxesDirective>
                </LinearGaugeComponent>
            </div>
        </div>
    )
}

export default StepProgressBar;